export default __webpack_public_path__ + "static/media/eventSlide4.7796bbe6.png";